import React from "react";
import { Icon } from "@iconify/react";
import { Route, Switch } from "react-router-dom";

import Authorities from "../../../auth/authorities";
import { getIsAuthorized } from "../../../utils/authorities";
import Dashboard from "../pages/Dashboard";
import Menu from "../pages/Menu";
import DashboardIcon from "@material-ui/icons/Dashboard";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import MenuInfo from "../pages/MenuInfo";
import Location from "../../PrestoExpressLocationApp/pages/Location";
import MappingStrategies from "../pages/MappingStrategies";
import PrinterMappingNew from "../pages/PrinterMappingNew";
import ProductConfiguration from "../pages/ProductConfiguration";
import MobileAppLogin from "../../PrestoExpressAccountsApp/pages/MobileAppLogin";
import MenuProductPage from "../pages/MenuApp/MenuProduct";
import MenuList from "../pages/MenuApp/MenuList";
import MenuDetailsView from "../pages/MenuApp/menuDetails/components/MenuDetailsView";
import menuDetails from "../pages/MenuApp/menuDetails";
import MenuDirectory from "../pages/MenuApp/MenuDirectory";
import ModifierGroups from "../pages/ModifierGroups";
import ThirdPartyPublish from "../pages/ThirdPartyPublish";

export const getSidebarRoutes = () => {
  const sidebarRoute = [
    {
      id: "DASHBOARD",
      title: "Dashboard",
      path: "",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "MENUS",
      title: "Menus",
      path: "/menu",
      icon: <MenuBookIcon />,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "PRINTER_MAPPING",
      title: "Printer Mapping",
      path: "/printerMapping",
      icon: <span className="material-symbols-outlined">print</span>,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "MAPPING_STRATEGIES",
      title: "Mapping Strategies",
      path: "/mappingStrategies",
      icon: <span className="material-symbols-outlined">alt_route</span>,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "MENUS",
      title: "Menus",
      path: "/menus",
      icon: <MenuBookIcon />,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "MODIFIER_GROUPS",
      title: "Modifier Groups",
      path: "/modifierGroups",
      icon: <MenuBookIcon />,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "THIRD_PARTY_PUBLISH",
      title: "3rd Party Publish",
      path: "/thirdPartyPublish",
      icon: <span className="material-symbols-outlined">publish</span>,
      isAuthorized: getIsAuthorized(Authorities.DASHBOARD_READ),
    },
    {
      id: "internal",
      title: "Internal Configurations",
      path: "/presto-menus/internalConfiguration",
      icon: <Icon icon="ri:admin-line" height="24" width="24" />,
      isAuthorized: getIsAuthorized(
        Authorities.PAYMENT_CONFIGURATION_READ,
      ),
      childRoutes: [
        {
          id: "internalConfiguration",
          title: "Product Configuration",
          path: "/internalConfiguration/productConfiguration",
          icon: <Icon icon="dashicons:admin-generic" height="24" width="24" />,
          isAuthorized: getIsAuthorized(
            Authorities.PAYMENT_CONFIGURATION_READ,
          ),
        },
      ],
    },
  ];
  return sidebarRoute;
};

export interface MenuAppRoutesProps {}

const MenuAppRoutes: React.FunctionComponent<MenuAppRoutesProps> = () => {
  return (
    <Switch>
      <Route path="/:locationId/presto-menus/menu" component={Menu} exact />
      <Route
        path="/:locationId/presto-menus/:publishedMenuId/presto-menus-info"
        component={MenuInfo}
        exact
      />
      <Route path="/:locationId/presto-menus" component={Dashboard} exact />
      <Route
        path="/:locationId/presto-menus/printerMapping"
        component={PrinterMappingNew}
        exact
      />
      <Route
        path="/:locationId/presto-menus/mappingStrategies"
        component={MappingStrategies}
        exact
      />
      <Route
        path="/:locationId/presto-menus/login"
        component={MappingStrategies}
        exact
      />
      <Route
        path="/:locationId/presto-menus/internalConfiguration/productConfiguration"
        component={ProductConfiguration}
        exact
      />
      <Route
        path="/:locationId/presto-menus/mobileLogin"
        component={MobileAppLogin}
        exact
      />
      {/* Menus routes - more specific routes first */}
      <Route
        path="/:locationId/presto-menus/menus/:menuId/product/:productId"
        component={MenuProductPage}
        exact
      />
      // Also keep the existing product route for root level products
      <Route
        path="/:locationId/presto-menus/menus/:menuId/product/:productId"
        component={MenuProductPage}
        exact
      />
      <Route
        path="/:locationId/presto-menus/menus/:menuId/directory/:directoryId+/product/:productId"
        component={MenuProductPage}
        exact
      />

      <Route
        path="/:locationId/presto-menus/menus/:menuId/directory/:directoryId+"
        component={MenuDirectory}
        exact
      />

      <Route
        path="/:locationId/presto-menus/menus/:menuId"
        component={menuDetails}
        exact
      />
      <Route
        path="/:locationId/presto-menus/menus"
        component={MenuList}
        exact
      />
       <Route
        path="/:locationId/presto-menus/modifierGroups"
        component={ModifierGroups}
        exact
      />
      <Route
        path="/:locationId/presto-menus/thirdPartyPublish"
        component={ThirdPartyPublish}
        exact
      />
      <Route path="/" component={Location} exact />
    </Switch>
  );
};

export default MenuAppRoutes;
